import React from "react";
import { Anchor, Stack, Text } from "@mantine/core";
import { SectionCard } from "@xplatform/design-system";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { ModelAlert } from "@models/adminMonitoring";
import { AdminTable, col } from "@components/AdminTable";
import { DeprecationBadge } from "@features/Providers";
import { moduleLabel } from "@utils/monitoringFormat";

/**
 * Deprecated models that were still called in the window, soonest retirement first,
 * with who calls them: the modules and services that must move before the date.
 */
const ModelAlerts: React.FC<{ alerts: ModelAlert[] | undefined }> = ({ alerts }) => {
  const { t } = useTranslation();
  if (!alerts?.length) return null;
  const columns = [
    col.twoLine<ModelAlert>("model", t("admin.insights.columns.model"), (a) => ({
      primary: a.model_id, secondary: a.provider_key,
    }), { mono: true }),
    col.badge<ModelAlert>("retires", t("admin.models.deprecation.retireOn"), (a) => <DeprecationBadge deprecation={a} />, 176),
    col.text<ModelAlert>("usedBy", t("admin.insights.modelAlerts.usedBy"),
      (a) => a.usage.map((u) => `${moduleLabel(u.module_name)} / ${u.service_name}`).join(", ")),
    col.date<ModelAlert>("lastUsed", t("admin.insights.columns.lastUsed"),
      (a) => a.usage.reduce((last, u) => (u.last_used > last ? u.last_used : last), "")),
    col.text<ModelAlert>("replacement", t("admin.models.deprecation.replacement"), (a) => a.replacement ?? "-",
                         { mono: true, width: "18%" }),
  ];
  return (
    <SectionCard title={t("admin.insights.modelAlerts.title")}>
      <Stack gap="sm">
        <Text size="sm" c="dimmed">
          {t("admin.insights.modelAlerts.description")}{" "}
          <Anchor component={Link} to="/admin/models?status=deprecated" size="sm">{t("admin.insights.modelAlerts.open")}</Anchor>
        </Text>
        <AdminTable columns={columns} data={alerts} getRowKey={(a) => `${a.provider_key}|${a.model_id}`} />
      </Stack>
    </SectionCard>
  );
};

export default ModelAlerts;
